import { isExternal } from '@/utils/is-external';

// get link href from strapi and check if starts with # (it is id) put # to be href value
export function getLinkHref(
  href: string,
  disabled: boolean,
): string | undefined {
  if (isExternal(href)) {
    return disabled ? undefined : href;
  }

  if (disabled) return '#';

  return href?.startsWith('#') ? '#' : href;
}

//if starts with # (it is id) use scrollIntoView function
export function handleLinkClick(
  e: React.MouseEvent,
  href: string,
  disabled: boolean,
) {
  if (disabled) {
    e.preventDefault();
    return;
  }

  // Smooth scroll for internal hash links
  if (href.startsWith('#')) {
    e.preventDefault();
    const targetElement = document.getElementById(href.slice(1));
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
